import { render, staticRenderFns } from "./shopify_general_tab.vue?vue&type=template&id=dadf389a&scoped=true&"
import script from "./shopify_general_tab.vue?vue&type=script&lang=js&"
export * from "./shopify_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadf389a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dadf389a')) {
      api.createRecord('dadf389a', component.options)
    } else {
      api.reload('dadf389a', component.options)
    }
    module.hot.accept("./shopify_general_tab.vue?vue&type=template&id=dadf389a&scoped=true&", function () {
      api.rerender('dadf389a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/shopify/location/tabs/shopify_general_tab.vue"
export default component.exports